import { render, staticRenderFns } from "./JishiBackClock.vue?vue&type=template&id=5821b76a&scoped=true"
import script from "./JishiBackClock.vue?vue&type=script&lang=js"
export * from "./JishiBackClock.vue?vue&type=script&lang=js"
import style0 from "./JishiBackClock.vue?vue&type=style&index=0&id=5821b76a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5821b76a",
  null
  
)

export default component.exports